import ContentLoader from "react-content-loader";

const idCheck = (val) => {
    if (!val) return false;

    const idRule = /^[a-z]+[a-z0-9]{5,19}$/g;
    return idRule.test(val);
};

const pwCheck = (val) => {
    if (!val) return false;

    const pwRule = /^(?=.*[a-zA-Z])(?=.*[0-9]).{5,19}$/;
    return pwRule.test(val);
};

const fnNotAdmin = () => {
    alert("관리자만 접근 가능한 메뉴입니다.");
    window.location.href = "/";
};

const fnNotLogin = () => {
    localStorage.removeItem("userinfo");
    alert("로그인 후 사용가능한 메뉴입니다.");
    window.location.href = "/Login";
};

const fnNotOfficers = () => {
    alert("이용 권한이 없는 메뉴입니다.");
    window.location.href = "/";
};

//게시판 신규작성 권한 확인
const canWrite = (kind, userType) => {
    const adminBoards = [
        "pds01",
        "pds02",
        "pds03",
        "pds04",
        "pds05",
        "pds06",
        "pds07",
        "pds08",
        "docu",
        "schedule",
        "gallery",
        "info",
        "news",
        "laws",
        "event",
    ];
    const generalBoards = ["free", "joboffer", "jobsearch"];

    if (adminBoards.includes(kind)) {
        return userType === "0" || userType === "1";
    }

    if (generalBoards.includes(kind)) {
        return ["0", "1", "2", "3"].includes(userType);
    }

    return false;
};

const getSubHeader = (kind) => {
    switch (kind) {
        case "info":
            return (
                <div className="col-12">
                    <h2>공지사항</h2>
                    <span>검사조합에서 알려 드립니다.</span>
                </div>
            );
        case "docu":
            return (
                <div className="col-12">
                    <h2>문서함</h2>
                    <span>검사조합 운영 및 참여에 필요한 문서를 공유해 드립니다.</span>
                </div>
            );
        case "pds01":
            return (
                <div className="col-12">
                    <h2>산업안전보건 자료실</h2>
                    <span>안전관리 및 건강 유지를 위한 다양한 자료를 찾아보세요.</span>
                </div>
            );
        case "pds02":
            return (
                <div className="col-12">
                    <h2>정비업무 자료실</h2>
                    <span>자동차 정비에 관한 모든 문서와 가이드를 한 곳에서</span>
                </div>
            );
        case "pds03":
            return (
                <div className="col-12">
                    <h2>기타 자료실</h2>
                    <span>
                        다양한 주제에 대한 추가적인 정보와 자료를 탐색할 수 있습니다.
                    </span>
                </div>
            );
        case "pds04":
            return (
                <div className="col-12">
                    <h2>서식 자료실</h2>
                    <span>
                        필요한 양식과 템플릿을 쉽고 빠르게 찾을 수 있는 공간입니다.
                    </span>
                </div>
            );
        case "pds05":
            return (
                <div className="col-12">
                    <h2>조합임원 자료실</h2>
                    <span>조합 운영 및 관리에 필요한 공식 문서와 자료를 확인하세요.</span>
                </div>
            );
        case "pds06":
            return (
                <div className="col-12">
                    <h2>검사업무 자료실</h2>
                    <span>자동차 검사와 관련된 모든 자료가 여기에!</span>
                </div>
            );
        case "pds07":
            return (
                <div className="col-12">
                    <h2>교육일정 및 신청안내</h2>
                    <span>
                        다양한 교육과정과 신청 방법에 대한 상세 정보를 확인하세요.
                    </span>
                </div>
            );
        case "pds08":
            return (
                <div className="col-12">
                    <h2>조합자료실</h2>
                    <span>
                        조합 직원들을 위한 전용 자료 공유 공간
                    </span>
                </div>
            );
        case "news":
            return (
                <div className="col-12">
                    <h2>자동차정비뉴스</h2>
                    <span>최신 트렌드와 업계 동향을 한 눈에 확인하세요.</span>
                </div>
            );
        case "laws":
            return (
                <div className="col-12">
                    <h2>자동차관련법규</h2>
                    <span>
                        정비 전문가들을 위한 최신 자동차 관련 법규와 규정 업데이트 정보를
                        제공합니다.
                    </span>
                </div>
            );
        case "joboffer":
            return (
                <div className="col-12">
                    <h2>구인정보</h2>
                    <span>자격을 갖춘 인재와의 만남, 지금 바로 시작하세요!</span>
                </div>
            );
        case "jobsearch":
            return (
                <div className="col-12">
                    <h2>구직정보</h2>
                    <span>당신의 능력에 딱 맞는 직장을 찾아보세요!</span>
                </div>
            );
        case "free":
            return (
                <div className="col-12">
                    <h2>자유게시판</h2>
                    <span>커뮤니티의 목소리, 여러분의 이야기를 나누세요!</span>
                </div>
            );
        case "schedule":
            return (
                <div className="col-12">
                    <h2>이사장 동정</h2>
                    <span>이사장의 활동 업데이트, 한눈에 알아보세요!</span>
                </div>
            );
        case "gallery":
            return (
                <div className="col-12">
                    <h2>포토갤러리</h2>
                    <span>각종 행사와 모임의 생생한 순간들을 확인해보세요!</span>
                </div>
            );
        case "event":
            return (
                <div className="col-12">
                    <h2>경조사</h2>
                    <span>조합원 간의 화합과 결속을 위한 공간입니다.</span>
                </div>
            );
        default:
            return (
                <div className="col-12">
                    <ContentLoader
                        speed={2}
                        width={600}
                        height={100}
                        viewBox="0 0 600 100"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                    >
                        <rect x="1" y="3" rx="0" ry="0" width="157" height="47" />
                        <rect x="2" y="65" rx="0" ry="0" width="335" height="32" />
                    </ContentLoader>
                </div>
            );
    }
};

const getServiceName = (kind) => {
    // 1. 관리자 작성 권한 게시판
    // - 공지사항 : InfoList (★)
    // - 문서수신 : DocuList (★)
    // - 자료실 : PdsList (★)
    // - 보도자료 : CastList (★)

    // 2. 관리자, 회원 작성권한 게시판
    // - 구인정보 : JobOfferList
    // - 구직정보 : JobSearchList
    // - 벼룩시장 : MarketList
    // - 자유게시판 : FreeList

    switch (kind) {
        case "info":
            return "Info";
        case "docu":
            return "Docu";
        case "pds01":
            return "Pds01";
        case "pds02":
            return "Pds02";
        case "pds03":
            return "Pds03";
        case "pds04":
            return "Pds04";
        case "pds05":
            return "Pds05";
        case "pds06":
            return "Pds06";
        case "pds07":
            return "Pds07";
        case "pds08":
            return "Pds08";
        case "news":
            return "News";
        case "laws":
            return "Laws";
        case "joboffer":
            return "JobOffer";
        case "jobsearch":
            return "JobSearch";
        case "gallery":
            return "Gallery";
        case "schedule":
            return "Schedule";
        case "free":
            return "Free";
        case "event":
            return "Event";
        default:
            return "";
    }
};

const getSub01 = (kind) => {
    switch (kind) {
        case "pds01":
        case "pds02":
        case "pds03":
        case "pds04":
        case "pds05":
        case "pds06":
        case "pds07":
        case "pds08":
            return "자료실";
        case "free":
        case "schedule":
        case "gallery":
        case "joboffer":
        case "jobsearch":
            return "정보광장";
        case "docu":
            return "문서함";
        case "laws":
            return "자동차관련법규";
        case "info":
            return "공지사항";
        case "news":
            return "자동차정비뉴스";
        case "event":
            return "경조사";
        default:
            return "";
    }
};

const getSub02 = (kind) => {
    switch (kind) {
        case "info":
            return "공지사항";
        case "docu":
            return "문서함";
        case "pds01":
            return "산업안전보건 자료실";
        case "pds02":
            return "정비업무 자료실";
        case "pds03":
            return "기타 자료실";
        case "pds04":
            return "서식 자료실";
        case "pds05":
            return "조합임원 자료실";
        case "pds06":
            return "검사업무 자료실";
        case "pds07":
            return "교육일정 및 신청안내";
        case "pds08":
            return "조합자료실";
        case "news":
            return "자동차정비뉴스";
        case "laws":
            return "자동차관련법규";
        case "joboffer":
            return "구인정보";
        case "jobsearch":
            return "구직정보";
        case "gallery":
            return "포토갤러리";
        case "schedule":
            return "이사장 동정";
        case "free":
            return "자유게시판";
        case "event":
            return "경조사";
        default:
            return "";
    }
};

const escapeHTML = function (s) {
    if (s) {
        return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
};

const wrapHTML = function (s) {
    if (s) {
        return s.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
    }
};

//파일 다운로드
const fnFileDownload = (fileUrl, fileName) => {
    fetch(fileUrl).then((response) => {
        response.blob().then((blob) => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
        });
    });
};

const getBackgroundImageCss = (id) => {
    if (id === "intro") return "bg-1";
    if (id === "docu") return "bg-2";
    if (
        ["pds01", "pds02", "pds03", "pds04", "pds05", "pds06", "pds08"].includes(id)
    )
        return "bg-3";
    if (id === "union_mem") return "bg-4";
    if (["free", "schedule", "gallery", "joboffer", "jobsearch", "pds07"].includes(id))
        return "bg-5";
    if (id === "info") return "bg-6";
    if (id === "news") return "bg-7";
    if (id === "laws") return "bg-6";
    if (id === "event") return "bg-8";
    if (id === "member") return "bg-9";
    if (id === "admin") return "bg-10";

    return "default-bg";
};

const cloneObj = (obj) => JSON.parse(JSON.stringify(obj));

export {
    idCheck,
    pwCheck,
    fnNotAdmin,
    fnNotLogin,
    cloneObj,
    getServiceName,
    getSub01,
    getSub02,
    getSubHeader,
    escapeHTML,
    wrapHTML,
    fnFileDownload,
    fnNotOfficers,
    canWrite,
    getBackgroundImageCss,
};
